/** Cache tag for orders (registered in apiSlice's tagTypes); the list and by-id endpoints share it, keyed by id. */
export enum OrderTags {
  Order = "Order",
}
